// 
// HighlighterEffect.js
// cenit-website
// 
// Created by Matías Martínez on 21/8/25
// 

class HighlighterEffect {
  
  constructor({ node, seed = Date.now(), jitter = 10 } = configuration){
    this.timing = {
      duration: 500,
      easing: "ease-in-out",
      fill: "forwards"
    };
    this.node = node;
    this.seed = seed;
    this.jitter = jitter;   // how “wiggly” the curve should be (px)
  }
  
  // tiny seeded PRNG (Mulberry32)
  rand() {
    let t = this.seed += 0x6D2B79F5;
    t = Math.imul(t ^ t >>> 15, t | 1);
    t ^= t + Math.imul(t ^ t >>> 7, t | 61);
    return ((t ^ t >>> 14) >>> 0) / 4294967296;
  }
  
  // random in [-range, +range]
  r(range) {
    return (this.rand() * 2 - 1) * range;
  }
  
  // Build a smooth-ish cubic path that stays inside the viewBox
  makePathD({ w = 194, h = 50 } = {}) {
    const cx = (x) => x;                    // keep x linear
    const cyBase = h * 0.5;                 // baseline mid-height
    const amp = Math.min(this.jitter, h * 0.45); // don’t clip the big stroke
    
    // Start and end x positions
    const x0 = 2, x3 = w - 2;
    
    // Random vertical offsets around the center line
    const y0 = cyBase + this.r(amp * 0.4);
    const y1 = cyBase + this.r(amp);
    const y2 = cyBase + this.r(amp);
    const y3 = cyBase + this.r(amp * 0.4);
    
    // Control points spaced roughly at 1/3 and 2/3 of width
    const c1x = w * 0.33, c2x = w * 0.66;
    
    // Slight randomization to control-point x as well
    const c1xr = c1x + this.r(w * 0.05);
    const c2xr = c2x + this.r(w * 0.05);
    
    return `M${cx(x0)} ${y0} C ${c1xr} ${y1}, ${c2xr} ${y2}, ${cx(x3)} ${y3}`;
  }
  
  render(){
    const w = 194, h = 50;
    const d = this.makePathD({ w, h });
    const body = `<svg preserveAspectRatio="none" width="${w}" height="${h}" viewBox="0 0 ${w} ${h}" fill="none" xmlns="http://www.w3.org/2000/svg"><path class="path" opacity="0.2" d="${d}" stroke="#FB5E15" stroke-width="40" stroke-linecap="round" fill="none"/></svg>`;
    
    const containerNode = document.createElement("span");
    containerNode.className = "highlighter";
    containerNode.innerHTML = body;
    
    this.node.appendChild(containerNode);
    this.path = containerNode.querySelector(".path");
  }
  
  animate(){
    if (!this.isPrepared) {
      this.render();
      this.isPrepared = true;
    }
    
    const { node, path, timing } = this;
    const length = path.getTotalLength();
    const animations = [
      path.animate(
        [
          { strokeDasharray: length, strokeDashoffset: length },
          { strokeDasharray: length, strokeDashoffset: 0 }
        ],
        timing
      ),
      node.animate(
        [
          { backgroundPosition: "0 0" },
          { backgroundPosition: "-100% 0" }
        ],
        timing
      )
    ];
    
    return Promise.all(animations.map(a => a.finished));
  }
  
}

export default HighlighterEffect;